import React, { useState, useRef } from "react";
import LeadFormStoreInfoComponent from "./LeadFormStoreInfoComponent";
import FirstStepForm from "./FirstStepForm";
import {
  FormValuesFirstStep,
  FormValuesSecondStep,
  TimeFormValues,
} from "./LeadFormComponentConfig";
import ThankyouPage from "./ThankyouPage";
import SecondStepForm from "./SecondStepForm";
import { getAllDistinctStates } from "@components/onlineScheduler/utils/utilFunctions";
import axios from "axios";
import getFullStateName, {
  StateAbbreviation,
} from "@storeLocator/utils/stateAbbrevsToNames";

const LeadFormController = () => {
  const [step, setStep] = useState(2);
  const [coords, setCoords] = useState(undefined);
  const [coordsState, setCoordsState] = useState("");
  const lastRefSubmit = useRef(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [formDataSecondStep, setFormDataSecondStep] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    CellPhone: "",
    HomeZipcode: "",
  });
  const [timeFormData, setTimeFormData] = useState({
    Time: "",
    StoreLocation: { identifier: "" },
  });

  const getState = async (coords: any) => {
    const baseURL = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.lat},${coords.lng}&key=AIzaSyA32l0Rj-4Gi1OtVu1jYSFdV-xeqAcVSX8`;
    try {
      const response = await fetch(baseURL);
      const data = await response.json();
      if (data.status === "OK") {
        const formmatedAddr = data.results[0].formatted_address.split(",");
        let country = formmatedAddr.pop().trim();
        if (country == "USA") {
          const state = formmatedAddr.pop().replace(/\d/g, "").trim();
          return state;
        }
      }
    } catch (error) {
      console.log("error", error);
    }
    return "";
  };
  const checkState = async (coords: any, dataState: any) => {
    if (Object.keys(coords).length === 0) {
      return false;
    }
    const states = getAllDistinctStates();
    const state = await getState(coords);
    if (state) {
      setCoordsState(state);
      return states.has(state);
    } else {
      return states.has(dataState);
    }
  };
  const handleStep2Submit = async (data: FormValuesSecondStep, coords: any) => {
    setFormDataSecondStep({ ...data });
    setCoords(coords);
    let hasState = await checkState(coords, data.State);
    if (hasState) {
      setStep(3);
    } else {
      setStep(5);
    }
  };
  const submitForm = async (timeData: any) => {
    const now = Date.now();
    if (now - lastRefSubmit.current < 6000) {
      return;
    }
    lastRefSubmit.current = now;
    if (formDataSecondStep) {
      const data = {
        FirstName: formDataSecondStep.FirstName,
        LastName: formDataSecondStep.LastName,
        Email: formDataSecondStep.Email,
        HomePhone: formDataSecondStep.CellPhone,
        ZipCode: formDataSecondStep.HomeZipcode,
        loantype: "P",
        Brand: "CheckSmart",
        SubID: "null",
        Source: "shortapp",
        LeadType: "shortapp",
        CampaignID: "FindAStorePage",
        DisplayLocation: timeData.StoreLocation.identifier,
      };
      const url = process.env.SHORT_APP_API_URL as string;
      const headers = {
        headers: {
          "Content-Type": "text/plain",
        },
      };
      try {
        const response = await axios.post(url, data, headers);
        const parsedRes = new DOMParser().parseFromString(
          response.data,
          "text/xml"
        );
        const formStatus = parsedRes
          .querySelector("speedycash")
          ?.getAttribute("result");

        if (formStatus === "accept") {
          setStep(4);
        } else {
          setStep(1);
          setErrorMessage("Something went wrong. Please try again.");
          setFormDataSecondStep({ ...formDataSecondStep });
        }
      } catch (error) {
        console.error("Error submitting the form", error);
      }
    }
    return false;
  };
  const handleStep3Submit = (data: any) => {
    setTimeFormData({ ...data });
    submitForm(data);
  };
  return (
    <>
      {step === 2 && (
        <SecondStepForm
          onNextStep={handleStep2Submit}
          formData={formDataSecondStep}
          errorMessage={errorMessage}
        />
      )}
      {step === 3 && coords && (
        <LeadFormStoreInfoComponent
          coords={coords}
          onNextStep={handleStep3Submit}
        />
      )}
      {step === 4 && (
        <ThankyouPage
          data={{
            ...formDataSecondStep,
            ...timeFormData,
          }}
        />
      )}
      {step === 5 && (
        <div className="flex flex-col gap-[15px] md:py-5">
          <h2 className="text-left font-body text-[32px] font-bold leading-[32px] tracking-[0.64px] text-white md:text-[48px] md:leading-[52px] md:tracking-[0.96px]">
            We don't offer loans in{" "}
            {getFullStateName(coordsState as StateAbbreviation)}
          </h2>
          <p className="font-body text-base leading-[24px] tracking-[0.16px] text-white">
            Unfortunately, we don't currently offer loans in{" "}
            {getFullStateName(coordsState as StateAbbreviation)}. Thank you for
            thinking of us.
          </p>
        </div>
      )}
    </>
  );
};

export default LeadFormController;
